module.exports = __webpack_public_path__ + "img/agromat.2bc25f5d.jpg";